<template>
  <div>
    <AppTextField
      v-model="searchQuery"
      class="my-2"
      :placeholder="$t('views.DocumentSearchPage.searchForProjects')"
      clearable
      density="compact"
      variant="outlined"
      clear-icon="close"
      @click:clear="searchQuery = ''"
    />
  </div>

  <div class="checkbox-group">
    <v-checkbox
      v-for="item in items"
      v-show="!trimmedSearchQuery || item.label.toLowerCase().includes(trimmedSearchQuery)"
      :key="item.key"
      v-model="internalValue"
      :value="item.key"
      :label="item.label"
      hide-details
    >
      <template #label="labelProps">
        <div class="label-wrapper">
          <div class="label-icon">
            <RoomTypeIcon
              class="checkbox-room-icon"
              :room="{ isDataroom: item.type === 'DR' }"
            />
          </div>
          <AppTooltip>
            <template #activator="{ props }">
              <span v-bind="props" class="label-text">
               {{ labelProps.label }}
              </span>
            </template>
            <span>{{ labelProps.label }}</span>
          </AppTooltip>
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import AppTextField from '@/common/AppTextField.vue'
import AppTooltip from '@/common/AppTooltip.vue'
import RoomTypeIcon from '@/common/RoomTypeIcon.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

/**
 * Internal proxy for v-model
 */
const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const searchQuery = ref('')
const trimmedSearchQuery = computed(() => searchQuery.value.trim().toLowerCase())
</script>

<style scoped lang="scss">
.label-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label-icon {
  flex: 0 0 auto;
}

.label-text {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 350px;
}

:deep(.v-selection-control__wrapper) {
  justify-content: flex-start;
  --v-selection-control-size: 32px;
}
</style>
